<template>
  <CButton :theme @click="toggle">
    <CIcon name="box-inventory"/>
    {{ $t(label) }}
  </CButton>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import CIcon from '@/shared/components/CIcon.vue';
  import CButton from '@/shared/components/buttons/CButton.vue';
  import StockStatus from '../constants/StockStatus';
  import { JobItemPartsData } from '../models/JobItem';

  const props = defineProps<{
    items: Array<JobItemPartsData>;
  }>();

  const hasAllStocked = computed(() => props.items.every(i => i.stockStatus === StockStatus.IN_STOCK));

  const theme = computed(() => hasAllStocked.value ? 'ghost-danger' : 'ghost-info');

  const label = computed(() => hasAllStocked.value ? 'partsModal.resetStock' : 'partsModal.allInStock');

  function toggle() {
    const newStatus = hasAllStocked.value ? null : StockStatus.IN_STOCK;
    props.items.forEach(i => i.stockStatus = newStatus);
  }
</script>